import { remoteImageStaticUrl } from "common/utils/remote-image";
import { ImagePlaceholder } from "./ImagePlaceholder";

const exampleImages = [
  {
    src: remoteImageStaticUrl(
      "gen/jiffy-weaver-ai-design-lab-placeholder/7a41cda70f9221d18ddfc75675e75c7dbf4adcbc.png"
    ),
    alt: "Tiger design example 1"
  },
  {
    src: remoteImageStaticUrl(
      "gen/jiffy-weaver-ai-design-lab-placeholder/c81498ed6c24549271366af66e73914446f34e72.png"
    ),
    alt: "Tiger design example 2"
  },
  {
    src: remoteImageStaticUrl(
      "gen/jiffy-weaver-ai-design-lab-placeholder/b14e3f7bbe6ef8c7132aa154daf673b653862088.png"
    ),
    alt: "Tiger design example 3"
  }
];

export function ExampleOutput() {
  return (
    <div className="mt-4">
      <h3 className="leading-7.5 mb-2 text-xl font-semibold text-gray-900">Example Output</h3>
      <div className="grid grid-cols-3 gap-2">
        {exampleImages.map((image, index) => (
          <ImagePlaceholder key={index} imageSrc={image.src} imageAlt={image.alt} />
        ))}
      </div>
    </div>
  );
}
